$(function () {
    const hashValue = $(location).attr('hash');

    // call an ajax function to store the hash as we may need it in the url for the dashboard
    $.ajax({
        url: "../Account/SaveDateHashFromUrl",
        data: { dateHash: hashValue },
    });

    $(".container-fluid").addClass("login");

});

const buttonOIDCLogin = Ladda.create(document.querySelector('#btnOIDCLogin'));
function OIDCLogin() {
    buttonOIDCLogin.start();

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If is Internet Explorer, does not call Alice logout
    {
        deleteAllCookies();
        window.location.href = "/Account/GasRedirectLogin";
    }
    else  // If another browser, call OIDC logout before login
    {
        fetch(SSOGASLogoutURL, { mode: 'no-cors' }).then(function () {
            fetch('/Account/logout', { mode: 'cors' }).then(function () {
                deleteAllCookies();
                window.location.href = "/Account/GasRedirectLogin";
            }).catch(function (error) {
                console.log('Request failed', error);
                buttonOIDCLogin.stop();
            });
        }).catch(function (error) {
            console.log('Request failed', error);
            buttonOIDCLogin.stop();
        });
    }
}

function deleteAllCookies() {
    sessionStorage.clear();
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}